export default "__VITE_ASSET__kemyhB6h__"